<template>
  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.723 5.79701C15.3578 4.47786 14.6245 3.31636 13.6402 2.42847L11.4622 4.63168C12.2566 5.28574 12.7923 6.24838 12.8899 7.33801V8.06059C12.9022 8.06059 12.9136 8.05676 12.9259 8.05676C14.0258 8.05676 14.9211 8.96238 14.9211 10.075C14.9211 11.1876 14.0258 12.0937 12.9259 12.0937C12.9136 12.0937 12.9022 12.0904 12.8899 12.0899V12.0937H9.73232H9V15.2083H12.8899V15.2064C12.9022 15.2064 12.9136 15.2083 12.9259 15.2083C15.7239 15.2083 18 12.9054 18 10.0755C18 8.29059 17.0934 6.71701 15.723 5.79701Z"
      fill="currentColor" />
    <path
      opacity="0.5"
      d="M6.89686 9.26179L9.13265 7.00013C9.13075 6.99773 9.12886 6.99581 9.12743 6.9939L6.89307 9.25413C6.89401 9.25652 6.89543 9.25892 6.89686 9.26179Z"
      fill="currentColor" />
    <path
      opacity="0.5"
      d="M6.89686 9.26179L9.13265 7.00013C9.13075 6.99773 9.12886 6.99581 9.12743 6.9939L6.89307 9.25413C6.89401 9.25652 6.89543 9.25892 6.89686 9.26179Z"
      fill="currentColor" />
    <path
      d="M9.00003 0.630127C5.14755 0.630127 2.01318 3.80076 2.01318 7.69782C2.01318 7.80947 2.02455 7.91824 2.02976 8.02845H5.10871C5.09971 7.9192 5.09213 7.80947 5.09213 7.69782C5.09213 5.51809 6.84524 3.7447 9.00003 3.7447C9.93271 3.7447 10.7896 4.0782 11.4622 4.63163L13.6402 2.42843C12.4049 1.3139 10.7816 0.630127 9.00003 0.630127Z"
      fill="currentColor" />
    <path
      opacity="0.5"
      d="M5.07414 12.0938H5.07319C4.78377 12.0938 4.51046 12.0281 4.26225 11.915L2.03119 14.1719C2.88051 14.8193 3.93209 15.2084 5.07319 15.2084H5.07414H9.00004V12.0938H5.07414Z"
      fill="currentColor" />
    <path
      d="M5.07414 12.0938H5.07319C4.78377 12.0938 4.51046 12.0281 4.26225 11.915L2.03119 14.1719C2.88051 14.8193 3.93209 15.2084 5.07319 15.2084H5.07414H9.00004V12.0938H5.07414Z"
      fill="currentColor" />
    <path
      d="M3.07895 10.0765C3.07895 8.96479 3.97421 8.05916 5.07316 8.05916C5.87984 8.05916 6.57853 8.54935 6.89258 9.25421L9.12695 6.99398C8.19805 5.74718 6.72774 4.94458 5.07268 4.94458C2.27842 4.94458 0 7.24458 0 10.0765C0 11.7492 0.801 13.2342 2.03116 14.1719L4.26221 11.915C3.56684 11.5997 3.07895 10.8954 3.07895 10.0765Z"
      fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Gcp',
};
</script>
